(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-options"] && !Shopify.designMode) return;
  try {
    const swiper = new Swiper('.swiper-header', {

    // Optional parameters
    direction: 'horizontal',
    loop: true,
    pauseOnMouseEnter: true,
    autoplay: {
      delay: 5000
    },
    speed: 800
  });

// Mobile menu functionality
  document.addEventListener('DOMContentLoaded', function() {
    const menuIcon = document.querySelector('.header-home-menu-icon');
    const asideContainer = document.querySelector('.header-home-aside-container');
    const closeButton = document.querySelector('.header-home-aside-close');
    const asideOptions = document.querySelector('.header-home-aside-options');

// Function to open menu
    function openMenu() {
      if (asideContainer && asideOptions) {
        asideContainer.style.display = 'flex';

// Small delay to ensure display change takes effect before transform
        setTimeout(() => {
          asideOptions.style.transform = 'translateX(0%)';
        }, 10);
      }
    }

// Function to close menu
    function closeMenu() {
      if (asideContainer && asideOptions) {
        asideOptions.style.transform = 'translateX(100%)';

// Wait for animation to complete before hiding
        setTimeout(() => {
          asideContainer.style.display = 'none';
        }, 300);
      }
    }

// Open menu when clicking menu icon
    if (menuIcon) {
      menuIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openMenu();
      });
    }

// Close menu when clicking close button
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeMenu();
      });
    }

// Close menu when clicking on the background (container) but not on the menu content
    if (asideContainer) {
      asideContainer.addEventListener('click', function(e) {

// Only close if clicking directly on the container (background), not on its children
        if (e.target === asideContainer) {
          closeMenu();
        }
      });
    }

// Prevent menu from closing when clicking on menu content
    if (asideOptions) {
      asideOptions.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

// Mobile submenu functionality
    function setupMobileSubmenus() {

// Handle main submenu toggles
      const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
      submenuToggles.forEach(toggle => {
        let clickCount = 0;
        let clickTimer = null;

        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          clickCount++;

          if (clickCount === 1) {
            clickTimer = setTimeout(() => {

// First click - toggle submenu
              const submenu = this.parentElement.parentElement.querySelector('[data-submenu]');

              if (submenu) { // Close other open submenus at the same level
                const allSubmenus = document.querySelectorAll('[data-submenu]');
                const allToggles = document.querySelectorAll('[data-submenu-toggle]');

                allSubmenus.forEach(menu => {
                  if (menu !== submenu && menu.classList.contains('open')) {
                    menu.classList.remove('open');
                  }
                });

                allToggles.forEach(otherToggle => {
                  if (otherToggle !== this && otherToggle.classList.contains('active')) {
                    otherToggle.classList.remove('active');
                  }
                });

// Toggle current submenu
                submenu.classList.toggle('open');
                this.classList.toggle('active');
              }

              clickCount = 0;
            }, 300);
          } else if (clickCount === 2) { // Second click - navigate to URL
            clearTimeout(clickTimer);
            const url = this.getAttribute('data-url');
            if (url && url !== '#' && url !== '') {
              window.location.href = url;
            }
            clickCount = 0;
          }
        });
      });

// Handle nested submenu toggles
      const nestedToggles = document.querySelectorAll('[data-nested-toggle]');
      nestedToggles.forEach(toggle => {
        let clickCount = 0;
        let clickTimer = null;

        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          clickCount++;

          if (clickCount === 1) {
            clickTimer = setTimeout(() => {

// First click - toggle nested submenu
              const nestedSubmenu = this.parentElement.parentElement.querySelector('[data-nested-submenu]');

              if (nestedSubmenu) { // Close other nested submenus
                const allNestedSubmenus = document.querySelectorAll('[data-nested-submenu]');
                const allNestedToggles = document.querySelectorAll('[data-nested-toggle]');

                allNestedSubmenus.forEach(menu => {
                  if (menu !== nestedSubmenu && menu.classList.contains('open')) {
                    menu.classList.remove('open');
                  }
                });

                allNestedToggles.forEach(otherToggle => {
                  if (otherToggle !== this && otherToggle.classList.contains('active')) {
                    otherToggle.classList.remove('active');
                  }
                });

// Toggle current nested submenu
                nestedSubmenu.classList.toggle('open');
                this.classList.toggle('active');
              }

              clickCount = 0;
            }, 300);
          } else if (clickCount === 2) { // Second click - navigate to URL
            clearTimeout(clickTimer);
            const url = this.getAttribute('data-url');
            if (url && url !== '#' && url !== '') {
              window.location.href = url;
            }
            clickCount = 0;
          }
        });
      });
    } // Initialize mobile submenus
    setupMobileSubmenus();
  });
  } catch(e) { console.error(e); }
})();

})();
